import React, { Component } from 'react'
import { Card, Button, Table, Select, Input, message } from 'antd'
import { PlusOutlined, SearchOutlined, EditOutlined, ContainerOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

import { connect } from 'react-redux'
import { req_page_product, req_edit_product } from '../../api'

import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

class Product extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    state = {
        products: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: '',
        loading: false
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_product(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_product = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const token = this.props.user.token
        this.setState({ loading: true })
        const result = await req_page_product(current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const {  total } = result
            const products = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ products, pagination })
        }
    }

    api_edit_product = async (product) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_edit_product(product, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            message.success(result.message)
            this.api_page_product(this.current)
        } else {
            message.error(result.message)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '物件名稱',
                dataIndex: 'ProductName',
                fixed: 'left',
                width: 60,
            },
            {
                title: '物件說明',
                dataIndex: 'ProductDetails',
                width: 80,
                responsive: ['md'],
            },
            {
                title: '價格',
                dataIndex: 'ProductPrice',
                sorter: true,
                width: 40,
                render: (price) => '$' + price,

            }, {
                title: '狀態',
                //dataIndex: 'ProductStatus',
                filters: [
                    { text: '在售中', value: 'ONLINE' },
                    { text: '已下架', value: 'OFFLINE' },
                ],
                filterMultiple: false,
                width: 50,
                render: (product) => {
                    const { Uid, ProductStatus } = product
                    const condition = 'STATUS'
                    const newStatus = ProductStatus === 'ONLINE' ? 'OFFLINE' : 'ONLINE'
                    return (
                        <span>
                            <span>{ProductStatus === 'ONLINE' ? '在售中' : '已下架'}</span>
                            <Button size='small' style={ProductStatus === 'ONLINE' ? { color: 'red' } : { color: 'green' }} onClick={() => this.handle_edit_status(Uid, newStatus, condition)}>{ProductStatus === 'ONLINE' ? (<EyeInvisibleOutlined />) : (<EyeOutlined />)}</Button>
                        </span>
                    )
                }
            }, {
                title: '操作',
                width: 50,
                fixed: 'right',
                render: (product) => {
                    return (
                        <span>
                            <Button type='dashed' size='small' style={{ color: 'green' }} onClick={() => this.props.history.push('/work/business/modify', product)}><EditOutlined /> 修改</Button>
                            <Button type='dashed' size='small' style={{ color: 'green' }} onClick={() => this.props.history.push('/work/business/details', { product })}><ContainerOutlined />明細</Button>
                        </span>
                    )
                }
            },
        ]

    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_page_size_change = (current, size) => {
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_product(current)
        })
    }

    handle_edit_status = (uid, newStatus, condition) => {
        const product = {
            Uid: uid,
            ProductStatus: newStatus,
            condition: condition,
        }
        this.api_edit_product(product)
    }

    handle_table_change = (pagination, filters, sorter) => {
        // console.log("sorter", sorter)
        if (sorter) {
            this.setState({ columnSort: sorter.field, orderBy: sorter.order }, () => {
                this.api_page_product(this.current)
            });
        }
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_product(this.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_product(this.current)
                });
            }
        }
    }

    ///////////////////////////////////////////////////////////// 

    render() {
        const { loading, products, pagination, searchField, searchValue } = this.state
        const title = (
            <span>
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='None'>搜索條件</Select.Option>
                    <Select.Option value='ProductName'>名稱</Select.Option>
                    <Select.Option value='ProductDetails'>描述</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' icon={<SearchOutlined />} onClick={() => this.api_page_product(1)}>查詢</Button>
            </span>
        )
        const extra = (
            <Button type='primary' icon={<PlusOutlined />} onClick={() => this.props.history.push('/work/business/modify')}>增加</Button>
        )
        return (
            <Card title={title} extra={extra}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={products}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        onChange: this.api_page_product,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(Product)